export default {
  GET_SUBSCRIBE_AMOUNT_INVITE_CODE: "/api/v1/subscribe-point/amount",
  GET_SUBSCRIBE_LAST_PAYMENT: "/api/v1/subscribe-order/last-payment",
  GET_SUBSCRIBE_OFFER: "/api/v1/subscribe-offer",
  GET_SUBSCRIBE_INFO: "/api/v1/subscribe-info",
  GET_SUBSCRIBE_ADDRESS_CHANGE: "/api/v1/subscribe-info/address-change-history",

  POST_SUBSCRIBE_BULK_INIT: "/api/v1/subscribe/payment-bulk",
  POST_SUBSCRIBE_ADDRESS_CHANGE: "/api/v1/subscribe-change/address",
  POST_SUBSCRIBE_CANCEL_RESERVATION: "/api/v1/subscribe-reservation",
  POST_SUBSCRIBE_CANCEL_RESERVATION_REVOKE:
    "/api/v1/subscribe-reservation/cancel-revoke",
  POST_SUBSCRIBE_REMOVE_SUBSCRIBE:
    "/api/v1/subscribe-reservation/remove-subscribe",
};
